import React, { useEffect, useRef, useCallback } from 'react'
import { Background, CardDropdownContainer, CartItems, EmptyCartP, ButtonWrapper } from './CartDropdownElements'
import CustomButton from '../CustomButton'
import CartItem from '../CartItem'
import { connect } from 'react-redux'
import { selectCartItems, selectCartHidden } from '../../redux/cart/cart.selectors'
import { createStructuredSelector } from 'reselect';
import { toggleCartHidden, toggleCloseCart } from '../../redux/cart/cart.actions'
import { withRouter } from 'react-router-dom'

const CartDropdown = ({ showDropdown, cartItems, history, dispatch }) => {
    const modalRef = useRef()

    const closeModal = e => {
        if (modalRef.current === e.target) {
            dispatch(toggleCloseCart())
        }
    }

    const keyPress = useCallback(e => {
        if (e.key === 'Escape') {
            dispatch(toggleCloseCart())
        }
    }, [dispatch])

    useEffect(() => {
        document.addEventListener('keydown', keyPress)

        const body = document.querySelector('body')
        body.style.overflow = showDropdown ? 'hidden' : 'auto'

        return () => {
            document.removeEventListener('keydown', keyPress)
            const body = document.querySelector('body')
            body.style.overflow = 'auto'
        }
    }, [keyPress, showDropdown])

    return (
        <>
            {showDropdown ?
                (<Background ref={modalRef} onClick={closeModal}>
                    <CardDropdownContainer>
                        <CartItems>
                            {
                                cartItems.length ?
                                    cartItems.map(cartItem => <CartItem key={cartItem.uuid} item={cartItem} />) :
                                    <EmptyCartP>Your cart is empty</EmptyCartP>
                            }
                        </CartItems>
                        {
                            cartItems.length ?
                                <ButtonWrapper>
                                    <CustomButton onClick={() => {
                                        history.push('/checkout')
                                        dispatch(toggleCartHidden())
                                    }}>
                                        Go To Basket
                    </CustomButton>
                                </ButtonWrapper>
                                : null
                        }
                    </CardDropdownContainer>
                </Background>
                ) :
                null
            }
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    showDropdown: selectCartHidden,
    cartItems: selectCartItems,
})

export default withRouter(connect(mapStateToProps)(CartDropdown))


// onMouseLeave={() => dispatch(toggleCartHidden())}